import { render, staticRenderFns } from "./SettingsTagMerger.vue?vue&type=template&id=5c5a5722&lang=pug&"
import script from "./SettingsTagMerger.vue?vue&type=script&lang=js&"
export * from "./SettingsTagMerger.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTagMerger.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports